import { User } from "@/models/user";

export class ActiveUser extends User {
	SessionCount:number = 0;

	public constructor(data?:any){
		super(data);
		if (!data)return;
		this.SessionCount = data.SessionCount || 0;
	}


	public toString(): string {
		let result = super.toString();
		result += `<span class='mls user'>${this.SessionCount} sessies</span>`;
		return result;
	}
}